import {
  WorkerCredentialConfigurationSchema,
  type WorkplaceProfileResponse,
  workplaceProfileResponseSchema,
  workplaceProfileUpdateSchema,
} from "@clipboard-health/contract-backend-main";
import { patch } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type z } from "zod";

export type WorkerCredentialConfiguration = z.infer<typeof WorkerCredentialConfigurationSchema>;

interface UpdateWorkerCredentialConfigurationParams {
  workplaceId: string;
  workerCredentialConfiguration: WorkerCredentialConfiguration;
}

export function useUpdateWorkerCredentialConfiguration(
  options: UseMutationOptions<
    WorkplaceProfileResponse,
    unknown,
    UpdateWorkerCredentialConfigurationParams
  > = {}
) {
  return useMutation({
    mutationFn: async ({ workplaceId, workerCredentialConfiguration }) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}`,
        data: {
          data: {
            id: workplaceId,
            type: "workplace",
            attributes: { workerCredentialConfiguration },
          },
        },
        bodySchema: workplaceProfileUpdateSchema,
        responseSchema: workplaceProfileResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.UPDATE_WORKER_CREDENTIAL_CONFIGURATION_FAILURE,
    },
    ...options,
  });
}
